import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function PublicSignDonePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const code = params.get('code');

  const handleCopy = async () => {
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      alert('Código copiado!');
    } catch {
      alert('Não foi possível copiar.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-sm border max-w-lg w-full p-6 text-center">

        <div className="text-4xl mb-3">✅</div>

        <h1 className="text-xl font-semibold text-gray-900">
          Documento assinado com sucesso
        </h1>

        <p className="text-sm text-gray-600 mt-2">
          Sua assinatura foi registrada com segurança.
        </p>

        {code && (
          <div className="mt-4 p-4 rounded-lg bg-gray-50 border">

            <div className="text-xs text-gray-500 mb-1">
              Código de validação
            </div>

            <div className="text-lg font-mono font-semibold text-gray-900 mb-3">
              {code}
            </div>

            <div className="flex gap-2 justify-center flex-wrap">

              <button
                onClick={handleCopy}
                className="px-3 py-1.5 text-xs bg-gray-200 rounded hover:bg-gray-300"
              >
                Copiar código
              </button>

              <button
                onClick={() => navigate(`/public/validar-documento/${code}`)}
                className="px-3 py-1.5 text-xs bg-purple-600 text-white rounded hover:bg-purple-700"
              >
                Validar documento
              </button>

            </div>
          </div>
        )}

        <p className="text-xs text-gray-500 mt-4">
          Você já pode fechar esta página.
        </p>

      </div>
    </div>
  );
}